import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {SecurityService} from '../security.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private securityService: SecurityService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const basicAuthUsername = 'sales-tool-client';
    const basicAuthPassword = '%6-E)GSj>urd[A4e';
    const basicAuthString = basicAuthUsername + ':' + basicAuthPassword;
    const basicAuthEncoded = btoa(basicAuthString);
    const authorizationHeaderValue = 'Basic ' + basicAuthEncoded;

    let newRequest;
    newRequest = req.clone();
    if (req.url.match('/oauth/token') !== null) {
      newRequest = req.clone({
        setHeaders: {
          Authorization: authorizationHeaderValue
        }
      });
    }
    if (req.url.match('/api/') !== null && this.securityService.isLoggedIn()) {
      newRequest = req.clone({
        setHeaders: {Authorization: 'Bearer' + this.securityService.authorization.access_token}
      });
    }
    return next.handle(newRequest)
    /*.pipe(catchError((error: HttpErrorResponse) => {
      if(error.status == 401) {
        this.securityService.refreshToken()
      }

      return next.handle(newRequest)
    }));*/
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptors/auth-interceptor.ts